// import pdfIcon from "./../../../../assets/images/pdf.png"; // Adjust the path as necessary

// function NavalArchitectureVesselConstructionTab() {
//     const documents = [
//       {
//         title: "CARGO AND TOWAGE APPROVAL",
//         modified: "2019/08/05  10.35 AM",
//         items: [
//           "Notification_of_intention_to_build_0.",
//           "INNotification_of_intention_to_build_0.",
//         ],
//       },
//       {
//         title: "Casualty Report",
//         modified: "2019/08/05  10.35 AM",
//         items: [
//           "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
//           "INS-701-08-03 Container Inspection Form",
//           "INS-701-09-01 Towage Inspection",
//         ],
//       },
//     ];



//   return (
//     <>
//       <div className="service-title font-700 mb-3 text-uppercase">
//         NAVAL ARCHITECTURE 
//         <span className="text-orange-ef3e33 font-400"> Vessel Construction </span>
//       </div>

//       <div className="row g-3 g-sm-4 g-md-5">
//         <div className="col-12">
//           <div className="accordion blackTab" id="blackTab">
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTabOne"
//                   aria-expanded="true"
//                   aria-controls="blackTabOne"
//                 >
//                   Notification of intention to build
//                 </button>
//               </h2>
//               <div
//                 id="blackTabOne"
//                 className="accordion-collapse collapse show"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <ul className="strip-ul">
//             {documents.map((doc, index) => (
//               <li key={index}>
//                 <div className="row g-4">
//                   <div className="col-auto">
//                     <img src={pdfIcon} alt="PDF icon" />
//                   </div>
//                   <div className="col">
//                     <div className="row g-4">
//                       <div className="col-md">
//                         <div className="font-18 font-600">File Name</div>
//                         <div className="font-16 font-400">
//                           <p className="text-orange-ef3e33 text-uppercase">{doc.title}</p>
//                           <ul className="list">
//                             {doc.items.map((item, i) => (
//                               <li key={i}>{item}</li>
//                             ))}
//                           </ul>
//                         </div>
//                       </div>
//                       <div className="col-md-auto">
//                         <div className="font-18 font-600">Modified</div>
//                         <div className="font-16 font-400">{doc.modified}</div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </li>
//             ))}
//           </ul>
//                  </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTabTwo"
//                   aria-expanded="false"
//                   aria-controls="blackTabTwo"
//                 >
//                   Check Sheets​
//                 </button>
//               </h2>
//               <div
//                 id="blackTabTwo"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <ul className="strip-ul">
//             {documents.map((doc, index) => (
//               <li key={index}>
//                 <div className="row g-4">
//                   <div className="col-auto">
//                     <img src={pdfIcon} alt="PDF icon" />
//                   </div>
//                   <div className="col">
//                     <div className="row g-4">
//                       <div className="col-md">
//                         <div className="font-18 font-600">File Name</div>
//                         <div className="font-16 font-400">
//                           <p className="text-orange-ef3e33 text-uppercase">{doc.title}</p>
//                           <ul className="list">
//                             {doc.items.map((item, i) => (
//                               <li key={i}>{item}</li>
//                             ))}
//                           </ul>
//                         </div>
//                       </div>
//                       <div className="col-md-auto">
//                         <div className="font-18 font-600">Modified</div>
//                         <div className="font-16 font-400">{doc.modified}</div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </li>
//             ))}
//           </ul>
//                  </div>
//               </div>
//             </div>

//           </div>
//         </div>


//       </div>
//     </>
//   );
// }

// export default NavalArchitectureVesselConstructionTab;


import React, { useEffect, useMemo, useState } from "react";
import { useFileContext } from "../../../../Contexts/FileContext";
import pdfIcon from "./../../../../assets/images/pdf.png";
import { WebApiURL } from "../../../../Constants/Constants";
import ssoImg1 from "./../../../../assets/images/150.png";
import CryptoJS from "crypto-js";
import { encryptFileIdValue } from "../../../../utils/encryption";

function NavalArchitectureVesselConstructionTab() {
  const { setComponentName, documents, loading } = useFileContext();
  const encodeBase64 = (str) => btoa(unescape(encodeURIComponent(str)));
  const secretKey = "MySAMSASecretKey2025"; // same as backend

  const encryptFileId = (fileId) => {
    const ciphertext = CryptoJS.AES.encrypt(fileId.toString(), secretKey).toString();
    return encodeURIComponent(ciphertext);
  };

  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    setComponentName("Naval Construction");
  }, [setComponentName]);

  // const sections = ["Accreditation", "Assessment & Certification", "Medical Practitioner", "Verification"];
  const sections = useMemo(() => {
    const sectionSet = new Set();
    documents?.forEach((doc) => {
      const section = typeof doc?.section === 'string' ? doc.section.trim() : '';
      if (section) sectionSet.add(section);
    });
    return Array.from(sectionSet);
  }, [documents]);

  const renderDocumentsBySection = (sectionName) => {
    const docs = documents?.filter(
      (doc) =>
        String(doc?.section || "").trim().toLowerCase() ===
        String(sectionName || "").trim().toLowerCase()
    );
    const grouped = docs?.reduce((acc, doc) => {
      const folder = doc?.folderName || doc?.section || "Uncategorized";
      if (!acc[folder]) acc[folder] = [];
      acc[folder].push(doc);
      return acc;
    }, {});

    return (
      <ul className="strip-ul">
        {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
          <li key={idx}>
            <div className="row g-4">
              <div className="col-auto">
                <img style={{ width: "40px" }} src={pdfIcon} alt="PDF icon" />
              </div>
              <div className="col">
                <div className="row g-4">
                  <div className="col-md">
                    <div className="font-18 font-600">File Name</div>
                    <div className="font-16 font-400">
                      <p className="text-orange-ef3e33 text-uppercase">
                        {folderName}
                      </p>
                      <ul className="list">
                        {folderDocs.map((doc, i) => (
                          <li key={i}>
                            {/* <a
                              href={`${WebApiURL}File/view/${encodeURIComponent(doc.fileId)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {doc.fileName}
                            </a> */}
                            <a href={`${WebApiURL}File/view/${encryptFileIdValue(doc.fileId)}`}
                              //href={`${WebApiURL}File/view/${encodeBase64(doc.fileId.toString())}`}
                              // target="_blank"
                              rel="noopener noreferrer"
                            >{doc.fileName}</a>


                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  {/* <div className="col-md-auto">
                    <div className="font-18 font-600">Modified</div>
                    <div className="font-16 font-400">
                      {folderDocs[0]?.modifiedDate
                        ? new Date(folderDocs[0].modifiedDate).toLocaleString()
                        : "—"}
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        NAVAL ARCHITECTURE <span className="text-orange-ef3e33 font-400">Vessel Construction</span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4">
        <div className="col-lg">
          {/* <p className="text-primary-color">
            PLEASE NOTE: “ Should the form show a “Please Wait..." ERROR MESSAGE, save/download the form to your device (desktop, laptop or phone) and open the form from there and not via your web browser”
          </p> */}

          <div className="col-lg">
            <p className="mb-3 text-primary-color">The  Centre maintain its role in ensuring safety of life and property at sea, maintain clean seas, whilst looking at adequate welfare of fishermen  and industry development initiatives.</p>

            <p className="mb-3 text-primary-color">The Centre is also secretariat to  National Fishing Forum, to ensure the competitiveness of the Industry  through stakeholder engagements;</p>


          </div>

        </div><div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>

        <div className="col-12">
          <div className="accordion blackTab" id="blackTab">
            {sections?.map((sectionName, idx) => (
              <div className="accordion-item" key={sectionName}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${activeIndex !== idx ? "collapsed" : ""}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#section-${idx}`}
                    aria-expanded={idx === 0 ? "true" : "false"}
                    aria-controls={`section-${idx}`}
                    onClick={() => {
                      setActiveIndex(idx);
                    }}
                  >
                    {sectionName}
                  </button>
                </h2>
                <div
                  id={`section-${idx}`}
                  className={`accordion-collapse collapse ${activeIndex === idx ? "show" : ""}`}
                  data-bs-parent="#blackTab"
                >
                  <div className="accordion-body px-0">
                    {loading ? (
                      <div>Loading documents...</div>
                    ) : (
                      renderDocumentsBySection(sectionName)
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default NavalArchitectureVesselConstructionTab;